import { useState } from "react";

import PaymentModal from "../../components/PaymentMethods/PaymentModal";

const Checkout = () => {
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const paymentData = {
    title: "800 CP",
    product: "Call of Duty: Mobile",
    price: "₦12,707.5",
    coins: 232,
    subtotal: "₦14,850",
    discount: "15%",
    fee: "₦100",
    totalCoins: 232,
    totalPrice: "₦12,707.5",
  };

  const availableCoins = 12000;

  const handleCheckout = () => {
    setShowPaymentModal(true);
  };
  return (
    <div className="w-full flex flex-col dark:bg-[#FFFFFF1A] gap-2 border border-border-border1 dark:border-tabs p-4 rounded-lg">
      <div className="bg-[#FFF9E7] h-10 dark:bg-[#DC6803] p-3 rounded-3xl mb-6 flex items-center justify-center">
        <img src="/png/Coins.png" alt="Coins" className="w-[24px] h-[24px]" />
        <p className="text-[10px] bp:text-sm text-[#DC6803] dark:text-white">
          You can earn 54 coins from this purchase
        </p>
      </div>
      <div>
        <div className="flex justify-between mb-1 bp:mb-2 font-inter">
          <span className="text-[#667085] dark:text-white text-xs bp:text-sm">
            Subtotal
          </span>
          <span className="text-black text-[10px] text-xs bp:text-sm dark:text-white ">
            14,500
          </span>
        </div>
        <div className="flex justify-between mb-1 bp:mb-2 font-inter">
          <span className="text-[#667085] text-[10px] text-xs bp:text-sm dark:text-white">
            Discount
          </span>
          <span className="text-black dark:text-white text-xs bp:text-sm">
            15%
          </span>
        </div>
        <div className="flex justify-between mb-1 bp:mb-2 font-inter">
          <span className="text-[#667085] text-xs bp:text-sm dark:text-white">
            Fee
          </span>
          <span className="text-black dark:text-white font-inter text-xs bp:text-sm">
            100
          </span>
        </div>
      </div>
      <div className="w-full  flex items-center dark:bg-[#FFFFFF1A] gap-2 border border-border-border1 dark:border-tabs p-2 rounded-lg mb-4">
        <img src="/png/Promo.png" alt="Promo" className="w-5 h-5" />
        <p className="dark:text-white text-[#667085] text-sm">Promo Code</p>
      </div>
      <div className="border-t border-dashed border-gray-200 dark:border-white py-4 font-inter">
        <div className="flex justify-between mb-1 bp:mb-2 font-inter">
          <span className="text-[#667085] text-xs bp:text-lg dark:text-white">
            Total
          </span>
          <div className="flex items-center gap-2">
            <div className="bg-[#039EF2] text-white px-1 bp:px-1.5 bp:py-0.5 rounded-2xl flex items-center gap-1">
              <div className="w-3 bp:w-4 h-3 bp:h-4 flex items-center justify-center">
                <img
                  src="/png/Coins.png"
                  alt="Coins"
                  className="w-[14px] h-[14px]"
                />
              </div>
              <p className="text-xs bp:text-sm font-semibold"> 232</p>
            </div>
            <span className="text-xs bp:text-base text-black dark:text-white">
              ₦12,707.5
            </span>
          </div>
        </div>
      </div>
      <button
        className="px-4 py-2 flex items-center justify-center text-[10px] bp:text-sm font-semibold text-white rounded-lg bg-gradient-to-b from-[#039EF2] to-[#027EC2]"
        onClick={handleCheckout}
      >
        <p> Checkout</p>
      </button>
      <p className="dark:text-white text-[#667085] text-xs">
        By clicking the button, you agree to the{" "}
        <a
          href="/terms-of-service"
          className="underline text-[#039EF2] dark:text-white"
        >
          Terms of Service
        </a>{" "}
        as well as the{" "}
        <a
          href="/terms-of-sales"
          className="underline text-[#039EF2] dark:text-white "
        >
          Terms of Sales
        </a>
      </p>
      {/* Payment Modal */}
      {/* <PaymentModal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        productData={paymentData}
        availableCoins={availableCoins}
        cpImageSrc="/png/CP.png"
      /> */}
    </div>
  );
};

export default Checkout;
